import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VChip,{staticStyle:{"position":"absolute","right":"8px","top":"8px","z-index":"8"},attrs:{"small":"","dark":"","color":_vm.chipColor}},[_vm._v("\n  "+_vm._s(_vm.chipText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }